/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActiveIntegrations} from '../api'

 export const useQueryGetActiveIntegrations = createReactQueryHook('getActiveIntegrations', getActiveIntegrations)
